<rappider-spin [spinning]="false">
  <div style="height: 300px;">
    <rappider-monaco-code-editor [ngModel]="localeCssValue"
                                 [options]="monacoEditorSettings"
                                 [showToolbar]="true"
                                 [toolbarButtons]="monacoAdditionalButtons"
                                 (ngModelChange)="onCssValueChange($event)"
                                 (toolbarButtonClicked)="onAdditionalButtonClick($event)">
    </rappider-monaco-code-editor>
  </div>
  <div class="code-mirror-save-button">
    <rappider-button text="Save"
                     type="primary"
                     (click)="onSaveCss()">
    </rappider-button>
  </div>
</rappider-spin>

<rappider-modal [visible]="modalMode"
                title="Page Style Customization"
                [fullScreen]="true"
                okText="Save"
                (cancelClick)="onPageStyleModalClose()"
                (okClick)="onSaveCss()">
  <ng-container *ngIf="monacoEditorInModalVisibility">
    <rappider-spin [spinning]="false">
      <div class="code-editor-wrapper">
        <rappider-monaco-code-editor [ngModel]="localeCssValue"
                                     [options]="monacoEditorSettings"
                                     [showToolbar]="false"
                                     (ngModelChange)="onCssValueChange($event)">
        </rappider-monaco-code-editor>
      </div>
    </rappider-spin>
  </ng-container>
</rappider-modal>
